import {Inject, Injectable} from "@angular/core";

@Injectable() 
export class RecognizerLauncherService {

    private worker;


    constructor(@Inject(String) private workerScript: string = 'resources/recognizerPlugoutWorker.js') {

      this.initializeWorker();

    }



    private initializeWorker() {
        if (window["recognitioniOSWorker"]) {
            this.worker = window["recognitioniOSWorker"];
        } else {
            this.worker = new Worker(this.workerScript);
        }
    }

    public getWorker() {
        return this.worker;
    }

}
